/* @license @google-recaptcha/core v1.0.5 */
var a=function(){return".grecaptcha-badge{display: none !important;}"};export{a as generateGoogleReCaptchaHiddenBadgeStyles};
//# sourceMappingURL=generateGoogleReCaptchaHiddenBadgeStyles.js.map
